export const HrocChecklistsPathSegments = {
  Checklist: 'checklist/:checklistId',
  UnsupportedKind: 'unsupported-kind'
} as const
